import { LitElement } from 'lit'

import { EventOptions } from './event'

export class DdsElement extends LitElement {
  emit<V = Record<PropertyKey, any>>(
    name: string,
    value?: V,
    options?: EventOptions,
  ) {
    const event = new CustomEvent<V>(name, {
      bubbles: true,
      cancelable: false,
      composed: true,
      detail: value ? ({ ...value } as V) : undefined,
      ...options,
    })

    this.dispatchEvent(event)

    return event
  }
}
